import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "md:border-t md:border-mcgard-gray-300 lg:border-0" }
const _hoisted_2 = {
  key: 0,
  class: "flex justify-end"
}
const _hoisted_3 = ["target", "onClick"]
const _hoisted_4 = ["target", "href"]

import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { storeToRefs } from 'pinia';
import { useI18n } from 'vue-i18n';
import { useScreenSize } from '@/composables/useScreenSize';
import { useCustomerStore } from '@/stores/useCustomerStore';
import { useThemeStore } from '@/stores/useThemeStore';
import {
  headerNavigation,
  headerB2bNavigation,
} from '@/configs/components/navigations';
import IconBurger from '@/components/icons/IconBurger';
import IconClose from '@/components/icons/IconClose';


export default /*#__PURE__*/_defineComponent({
  __name: 'NavigationMenu',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const customerStore = useCustomerStore();
const { isB2B } = storeToRefs(customerStore);
const themeStore = useThemeStore();
const {
  isShowNavigationMenu,
  isShowLanguageMenu,
} = storeToRefs(themeStore);
const { locale } = useI18n();
const { isMobile } = useScreenSize();

const menuGroup = computed(() => {
  return route.meta && route.meta.routeParent ? route.meta.routeParent : '';
});
const navigationMenu = computed(() => {
  if (isB2B.value) {
    return headerB2bNavigation.map((item) => {
      if (item.value === 'products') {
        return {
          internalLink: item.internalLink,
          label: item.label,
          value: item.value,
        };
      }
      return item;
    });
  } else {
    return headerNavigation.map((item) => {
      if (item.value === 'products') {
        return {
          externalLink: item.externalLink,
          isNewTab: item.isNewTab,
          label: item.label,
          value: item.value,
        };
      }
      return item;
    });
  }
});

function toggleMenu () {
  if (!isShowNavigationMenu.value && isShowLanguageMenu.value) {
    themeStore.closeLanguageMenu();
  }
  themeStore.toggleShowNavigationMenu();
}
function closeMenu () {
  themeStore.closeNavigationMenu();
}
function goToPage (link: string) {
  themeStore.closeNavigationMenu();
  router.push({ name: link });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "block md:hidden px-5",
      onClick: toggleMenu
    }, [
      _createVNode(_unref(IconBurger))
    ]),
    _createElementVNode("div", {
      class: _normalizeClass([
        'absolute top-[63px] left-0 right-0 md:static flex flex-col',
        'w-full md:w-auto h-[calc(100%_-_63px)] md:h-full',
        'border-y border-mcgard-gray-300 md:border-0',
        'bg-mcgard-gray-200 md:bg-transparent z-[5]',
        _unref(isShowNavigationMenu) || !_unref(isMobile) ? 'translate-x-0' : '-translate-x-full',
        _unref(isMobile) ? 'transition-all duration-200' : null,
      ])
    }, [
      (_unref(isMobile))
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("button", {
              class: "py-2 px-4",
              onClick: closeMenu
            }, [
              _createVNode(_unref(IconClose))
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("ul", {
        class: _normalizeClass([
          'flex items-center justify-center w-full md:w-auto h-full mx-auto',
          _unref(isMobile) ? 'flex-col' : 'flex-row',
        ])
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(navigationMenu), (item, index) => {
          return (_openBlock(), _createElementBlock("li", {
            key: `headerNav${index}`,
            class: _normalizeClass([
            'relative w-full md:w-auto h-auto md:h-full mx-4 uppercase text-2xl md:text-[13px] cursor-pointer group',
            'after:absolute after:content-[\'\'] after:bottom-0 after:left-0',
            'after:w-full after:h-[5px] after:bg-mcgard-primary',
            _unref(menuGroup) === item.value && !_unref(isMobile) ?
              'after:block'
              : 'after:hidden',
            _unref(isMobile) ? null : 'hover:after:block',
          ])
          }, [
            (item.internalLink)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  class: _normalizeClass([
              'relative flex items-center justify-center h-full py-4 md:py-2 px-4 md:px-0',
              'text-center font-roboto-black-italic leading-none cursor-pointer',
              _unref(menuGroup) === item.value && !_unref(isMobile) ? 'text-mcgard-gray-600' : 'text-mcgard-gray-900',
              _unref(menuGroup) === item.value && _unref(isMobile) ? 'bg-mcgard-primary text-white' : null,
              _unref(menuGroup) !== item.value && !_unref(isMobile) ? 'group-hover:text-mcgard-primary' : null,
              _unref(isMobile) ? 'group-hover:bg-mcgard-primary group-hover:text-white' : '',
            ]),
                  target: item.isNewTab ? '_blank' : undefined,
                  onClick: ($event: any) => (goToPage(item.internalLink))
                }, _toDisplayString(_ctx.$t(item.label)), 11, _hoisted_3))
              : (item.externalLink)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 1,
                    class: _normalizeClass([
              'relative flex items-center justify-center h-full py-4 md:py-2 px-4 md:px-0',
              'text-center font-roboto-black-italic leading-none cursor-pointer',
              _unref(menuGroup) === item.value ? 'text-mcgard-gray-600' : 'text-mcgard-gray-900',
              _unref(menuGroup) === item.value && _unref(isMobile) ? 'bg-mcgard-primary text-white' : null,
              _unref(menuGroup) !== item.value && !_unref(isMobile) ? 'group-hover:text-mcgard-primary' : null,
              _unref(isMobile) ? 'group-hover:bg-mcgard-primary group-hover:text-white' : '',
            ]),
                    target: item.isNewTab ? '_blank' : undefined,
                    href: item.externalLink[_unref(locale).toLowerCase()]
                  }, _toDisplayString(_ctx.$t(item.label)), 11, _hoisted_4))
                : (_openBlock(), _createElementBlock("a", {
                    key: 2,
                    class: _normalizeClass([
              'relative flex items-center justify-center h-full py-4 md:py-2 px-4 md:px-0',
              'text-center font-roboto-black-italic leading-none cursor-pointer',
              _unref(menuGroup) === item.value ? 'text-mcgard-gray-600' : 'text-mcgard-gray-900',
              _unref(menuGroup) === item.value && _unref(isMobile) ? 'bg-mcgard-primary text-white' : null,
              _unref(menuGroup) !== item.value && !_unref(isMobile) ? 'group-hover:text-mcgard-primary' : null,
              _unref(isMobile) ? 'group-hover:bg-mcgard-primary group-hover:text-white' : '',
            ])
                  }, _toDisplayString(_ctx.$t(item.label)), 3))
          ], 2))
        }), 128))
      ], 2)
    ], 2)
  ]))
}
}

})